function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "var(--k-bg-f2f5f9)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3571 9H7.64286C7.28728 9 7 9.28728 7 9.64286V22.5C7 22.8556 7.28728 23.1429 7.64286 23.1429H24.3571C24.7127 23.1429 25 22.8556 25 22.5V9.64286C25 9.28728 24.7127 9 24.3571 9ZM23.5536 13.1786H19.2946V10.4464H23.5536V13.1786ZM23.5536 17.6786H19.2946V14.4643H23.5536V17.6786ZM13.9911 14.4643H18.0089V17.6786H13.9911V14.4643ZM18.0089 13.1786H13.9911V10.4464H18.0089V13.1786ZM8.44643 14.4643H12.7054V17.6786H8.44643V14.4643ZM8.44643 10.4464H12.7054V13.1786H8.44643V10.4464ZM8.44643 18.9643H12.7054V21.6964H8.44643V18.9643ZM13.9911 18.9643H18.0089V21.6964H13.9911V18.9643ZM23.5536 21.6964H19.2946V18.9643H23.5536V21.6964Z",
  fill: "var(--k-fg-88959e)"
});

function SvgTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.06bf4acb.svg";
export { ForwardRef as ReactComponent };